import styled from 'styled-components';

export const Button = styled.button`
    background-image: url(${props => props.background}) !important;
`

export const ContentWrapper = styled.div`
    position: relative;
    margin-right: 0;
    margin-left: 0;
    padding-right: 2rem;
    padding-left: 2rem;
    width: auto;
`